"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceScheduleResponse = exports.UserServiceScheduleRequest = void 0;
var event_sequence_1 = require("../event-sequence");
var single_event_1 = require("../single-event");
/** Запрос на поиск расписания услуги */
var UserServiceScheduleRequest = /** @class */function () {
  function UserServiceScheduleRequest(values) {
    this.user_service_id = values.user_service_id;
    this.teacher_id = values.teacher_id;
    this.student_id = values.student_id;
    this.date_from = values.date_from ? new Date(values.date_from) : null;
    this.date_to = values.date_to ? new Date(values.date_to) : null;
  }
  return UserServiceScheduleRequest;
}();
exports.UserServiceScheduleRequest = UserServiceScheduleRequest;
/** Ответ на запрос на поиск расписания услуги */
var UserServiceScheduleResponse = /** @class */function () {
  function UserServiceScheduleResponse(values) {
    this.service_events = (values.service_events || []).map(function (event) {
      return new event_sequence_1.EventsSequence(event);
    });
    this.student_schedule = (values.student_schedule || []).map(function (event) {
      return new single_event_1.SingleEvent(event);
    });
  }
  return UserServiceScheduleResponse;
}();
exports.UserServiceScheduleResponse = UserServiceScheduleResponse;
